import { render } from "./cu-aside.vue?vue&type=template&id=17361cbe&scoped=true"
import script from "./cu-aside.vue?vue&type=script&lang=js"
export * from "./cu-aside.vue?vue&type=script&lang=js"

import "./cu-aside.vue?vue&type=style&index=0&id=17361cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17361cbe"]])

export default __exports__